import React, { useEffect, useState } from 'react';
import "../Header/NavBar.css";
import { FaInstagram, FaFacebookSquare, FaWhatsapp } from "react-icons/fa";
import { IoCart } from "react-icons/io5";
import { ImUser } from "react-icons/im";
import { Badge, Drawer } from 'antd';
import Logo from "../../../Images/Woodsy.png";
import { Link, useLocation } from 'react-router-dom';
import { IoIosCall, IoMdSearch } from "react-icons/io";
import { LuMenu } from "react-icons/lu";
import { getToken } from "../../../services/localStorageServices";
import { useSelector } from "react-redux";
import { FaYoutube } from "react-icons/fa";
import { IoMailOutline } from "react-icons/io5";
import { FaXTwitter } from "react-icons/fa6";
import axios from 'axios';
import AddtoCart from '../../../Pages/AddtoCart';
import { useCartContext } from '../../../context/addToCart';


const Header = ({ someProp }) => {
    const location = useLocation();
    const [isSticky, setIsSticky] = useState(false);
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const { cartValue, setCartCount, setCartValue } = useCartContext();
    const { access_token } = getToken();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const { token } = useSelector((state) => state.auth);

    const handleScroll = () => {
        if (window.scrollY > 20) {
            setIsSticky(true);
        } else {
            setIsSticky(false);
        }
    };

    const toggleSearch = () => {
        setIsSearchOpen(!isSearchOpen);
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const navbarClass = someProp ? 'black-navbar' : 'transparent-navbar';

    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    const handleMenuClick = () => {
        setOpen(false);
    };


    const handleFetch = async () => {
        try {
            setLoading(true);
            const resp = await axios.get(`https://api.woodsy.co.in/api/wood-images-new`);

            if (resp && resp.data) {
                const categoryArray = Array.isArray(resp.data)
                    ? resp.data
                    : Object.values(resp.data); // convert object to array
                setData(categoryArray);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        const dbounce = setTimeout(() => {
            handleFetch();
        }, 1000);
        return () => {
            clearTimeout(dbounce);
        };
    }, []);

    // Filter categories to only show those with products
    const filteredCategories = data.filter(elem => {
        const main = elem?.main_category;
        if (!main || !main.subcategory || main.subcategory.length === 0) {
            return false;
        }

        // Check if any subcategory has at least one brand with at least one product
        return main.subcategory.some(sub =>
            sub.brands && sub.brands.some(brand =>
                brand.products && brand.products.length > 0
            )
        );
    });

    return (
        <>
            <section className={`Header-section-main-con ${isSticky ? 'sticky' : ''} ${navbarClass}`}>
                <div className='Header-Section-con'>
                    <div className='row'>
                        <div className='col-4 d-flex justify-content-start align-items-center'>
                            <div className='Header-social-media-main-con'>
                                <div className='Header-social-media-con'>
                                    <a href='https://www.instagram.com/woodsy.official/?fbclid=IwZXh0bgNhZW0CMTEAAR32uMU1VvCrHqTcb2TIJu_lx2iJmlx3o5zLnIFzU1lrTBCUg7IsAmzp__s_aem_ZuflNhluisS6ikGZgnvK5Q' target='blank'><FaInstagram /></a>
                                    <a href='https://www.facebook.com/people/Woodsyofficial/61573711121095/' target='blank'><FaFacebookSquare /></a>
                                    <a href="mailto: darveshzakia81@gmail.com" target='blank'><IoMailOutline /></a>
                                    <a href="https://wa.me/+917666666555?text=" target='blank'><FaWhatsapp /></a>
                                    <a href="tel:+919833553720" target='blank'><IoIosCall /></a>
                                </div>
                                <div className='header-responsive-search-and-menu-btn-con'>
                                    <div className='header-responsive-search-and-menu-btn'>
                                        <div className='header-responsive-menu-btn' onClick={showDrawer}>
                                            <LuMenu />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-4 d-flex justify-content-center align-items-center'>
                            <div className='Header-Logo-Main-Con'>
                                <Link to="/">
                                    <div className='Header-Logo-Con'>
                                        <img src={Logo} alt='Logo' />
                                    </div>
                                </Link>
                            </div>
                        </div>
                        <div className='col-4 d-flex justify-content-end align-items-center'>
                            <div className='Header-Icons-Main-con'>
                                <div className='Header-Icons-con'>
                                    <div className='Header-Profile-Icons-Con'>
                                        <Link to={token ? "/order" : "/account/sign-in"}>
                                            <button title={token ? "order" : "Sign In"}>
                                                <ImUser />
                                            </button>
                                        </Link>
                                    </div>
                                    <div className='Header-Profile-Icons-Con'
                                        data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasRight"
                                        aria-controls="offcanvasRight">
                                        <Badge size="small" count={cartValue.length}>
                                            <IoCart />
                                        </Badge>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='col-md-12'>
                            <div className='d-flex justify-content-center'>
                                <div className='main-menu-con'>
                                    <Link to="/">Home</Link>
                                    <Link to="/product">Product</Link>

                                    {/* <div className="dropdown">
                                        <span className="dropdown-title">Product</span>
                                        <div className="dropdown-content">
                                            {filteredCategories.map((elem) => {
                                                const main = elem?.main_category;
                                                // Filter subcategories that have products
                                                const filteredSubcategories = main?.subcategory?.filter(sub =>
                                                    sub.brands && sub.brands.some(brand =>
                                                        brand.products && brand.products.length > 0
                                                    )
                                                );

                                                if (filteredSubcategories && filteredSubcategories.length > 0) {
                                                    return (
                                                        <div className="dropdown-item" key={main?.slug || main?.name}>
                                                            <Link
                                                                to={`/product/${main?.slug}`}
                                                                className="main-category-link"
                                                            >
                                                                {main?.name}
                                                            </Link>
                                                            <div className="sub-dropdown">
                                                                {filteredSubcategories.map((sub) => (
                                                                    <Link
                                                                        to={`/product/${main?.slug}/${sub?.slug}`}
                                                                        key={sub?.slug}
                                                                    >
                                                                        {sub?.name}
                                                                    </Link>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                                return null; // Don't render main category if no subcategories have products
                                            })}
                                        </div>
                                    </div> */}


                                    <Link to="/about">About Us</Link>
                                    <Link to="/contact">Contact Us</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className='menu-side-bar-con'>
                <Drawer onClose={onClose} open={open} placement="left"> {/* Added placement prop */}
                    <div className='menu-side-bar-menu-con'>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/">Home</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/product">Product</Link>
                        </div>
                        <div
                            className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/about">About Us</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/contact">Contact Us</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/terms-conditions">Terms & Conditions</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/return-policy">Return Policy</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/shipping">Shipping</Link>
                        </div>
                        <div className='menu-side-bar-menu' onClick={handleMenuClick}>
                            <Link to="/return-policy">Return Policy</Link>
                        </div>
                    </div>

                    <div className='menu-side-bar-menu-second-option-cosial-media'>
                        <a href='https://www.instagram.com/woodsy.official/?fbclid=IwZXh0bgNhZW0CMTEAAR32uMU1VvCrHqTcb2TIJu_lx2iJmlx3o5zLnIFzU1lrTBCUg7IsAmzp__s_aem_ZuflNhluisS6ikGZgnvK5Q' target='blank'><FaInstagram /></a>
                        <a href='https://www.facebook.com/people/Woodsyofficial/61573711121095/' target='blank'><FaFacebookSquare /></a>
                        <a href="mailto: darveshzakia81@gmail.com" target='blank'><IoMailOutline /></a>
                    </div>
                </Drawer>
            </div>

            <AddtoCart />
        </>
    );
};

export default Header;